/**
 * Lib.Common: String Formatting
 */


import $locale from './locale';


export default {

    /**
     * DEPRECATED
     */
    fromNumber(val, options = {}) {
        val = +val;
        if (isNaN(val)) {
            return options.fallback == null ? '—' : options.fallback; // em dash
        }
        let suffix = '';
        if (options.abbreviate) {
            const tier = Math.log(Math.abs(val)) * Math.LOG10E / 3 | 0;
            if (tier) {
                suffix = 'KMBTPE'.charAt(tier - 1);
                val = val / Math.pow(10, tier * 3);
            }
            if (options.precision == null) {
                options.precision = tier ? 2 : 0;
            }
        }
        return val.toLocaleString($locale.current, {
            numberingSystem: 'latn',
            minimumFractionDigits: Math.max(
                options.minPrecision | 0,
                options.precision | 0),
            maximumFractionDigits: Math.min(
                options.maxPrecision == null ? 20 : options.maxPrecision,
                options.precision == null ? 20 : options.precision),
            useGrouping: options.grouping,
            style: options.percent ? 'percent' : void 0
        }) + suffix;
    },


    /**
     * Convert formatted string using `,` as optional group separator and `.` as decimal point, to number.
     * String may be abbreviated with 'K', 'M', 'B', 'T', 'P', or 'E' suffix.
     * String may also have `%` as suffix to indicate it needs to be divided by 100.
     */
    toNumber(val) {
        if (typeof val === 'number') {
            return val;
        } else if (typeof val === 'string') {
            const part = val.match(/^([+-]?)([\d,]+)(\.\d*)?([KMBTPE%]?)$/);
            if (part) {
                const factor = {
                    '+': 1,
                    '-': -1,
                    '': 1
                }[part[1]] * {
                    'K': 1E3,
                    'M': 1E6,
                    'B': 1E9,
                    'T': 1E12,
                    'P': 1E15,
                    'E': 1E18,
                    '%': .01,
                    '': 1
                }[part[4]];
                // This way avoids precision errors
                if (part[3]) {
                    return parseInt(part[2].replace(/,/g, '')) * factor + parseFloat(part[3]) * factor;
                } else {
                    return parseInt(part[2].replace(/,/g, '')) * factor;
                }
            }
        }
        return NaN;
    },


    /**
     * Escape characters to be used in a regular expression.
     */
    escapeRegex(str) {
        return $string.escapeUnicode(str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'));
    },


    /**
     * Convert characters outside ASCII range to \uxxxx format.
     */
    escapeUnicode(str) {
        return ('' + str)
            .replace(/[^\0-~]/g, ch =>
                '\\u' + ('000' + ch.charCodeAt().toString(16)).slice(-4));
    },


    /**
     * Unescape characters in \uxxxx format.
     */
    unescapeUnicode(str) {
        return ('' + str)
            .replace(/\\u([\da-f]{4})/ig, (all, code) =>
                String.fromCharCode(parseInt(code, 16)));
    },


    /**
     * Escape <, >, and & using HTML escape sequences.
     */
    escapeHTML(str) {
        return str == null ? str : ('' + str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    },


    /**
     * Unescape all HTML escape sequences.
     */
    unescapeHTML(str) {
        return new DOMParser().parseFromString(str, 'text/html').documentElement.textContent;
    }
}
